import { render, staticRenderFns } from "./ProfitStatistics1.vue?vue&type=template&id=1899a4e6&scoped=true&"
import script from "./ProfitStatistics1.vue?vue&type=script&lang=js&"
export * from "./ProfitStatistics1.vue?vue&type=script&lang=js&"
import style0 from "./ProfitStatistics1.vue?vue&type=style&index=0&id=1899a4e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1899a4e6",
  null
  
)

export default component.exports